import React, { Component } from 'react';
import withAuth from '../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import Gallery from '../Components/Gallery/Gallery';


class GalleryPhotoContainer extends Component {
    constructor(props) {
        super(props);
        let user = JSON.parse(localStorage.getItem('user')).user;

        this.state = {
            apikey: user.apikey,
            username: user.email,
            role: user.role,
        };
    }

    render() {
        return (
            <div>
                <Navbar history={this.props.history} />
                <div className="main-body" style={{ padding: 20 }}>
                    <h2 style={{ marginBottom: 20 }}>Photo Gallery</h2>
                    <p style={{ color: '#666', marginBottom: 20 }}>
                        Upload photos with captions. They will appear on the public
                        page at <code>/gallery/photo</code>.
                    </p>

                    <Gallery
                        type="PHOTO"
                        dept="COLLEGE"
                        history={this.props.history}
                        apikey={this.state.apikey}
                        username={this.state.username}
                    />
                </div>
            </div>
        );
    }
}

export default withAuth(GalleryPhotoContainer);



// WEBPACK FOOTER //
// ./src/Containers/GalleryPhotoContainer.js